// extracted by mini-css-extract-plugin
export default {"text":"yuiccm","legalDot":"sYjGTJ","legalLink":"E3X2vm"};